import { ModalBehaviorSettingFormInTimelineComponent } from './../modal/setting/behavior/modal-behavior-setting-form-in-timeline/modal-behavior-setting-form-in-timeline.component'
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'

import { AppElementRouting } from './appElement.routing'
import { AppElementComponent, SafeHtmlPipe } from './appElement.component'
import { LayoutAppElementComponent } from './layout_app_element/layout-app-element.component'
import { ModalMailHistoryComponent } from '../modal/clinic/modal-mail-history.component'
import { ModalBroadcastMailFailedComponent } from '../modal/clinic/broadcast/modal-broadcast-mail-failed.component'
import { SubmenuboxComponent } from '../../submenubox/submenubox.component'
import { ModalAuditComponent } from '../modal/clinic/audit/modal-audit.component'
import { ModalLanguageComponent } from '../modal/language/modal-language.component'
import { ModalStaffEditComponent } from '../modal/setting/staff/modal-staff-edit.component'
import { ModalService } from '../../services/modal.service'
import { ScrollbarModule } from 'ngx-scrollbar'
import { ModalClinicEditComponent } from '../modal/setting/clinic/modal-clinic-edit.component'
import { ModalCommonSaveComponent } from '../modal/setting/common/modal-common-save.component'
import { ModalNewClientDoctorComponent } from '../modal/client/new-client/modal-new-client.component'
import { ModalMailComponent } from '../modal/setting/mail/modal-mail.component'
import { SelectclientService } from '../../services/client/selectclient.service'
import { ClientDetailServices } from '../../services/ClientDetail.services'
import { ProfileClientComponent } from '../modal/client/profile-client/profile-client.component'
import { QRCodeModule } from 'angular2-qrcode'

import { OnsenModule } from 'ngx-onsenui'
import { ModalCommunicationNewroomComponent } from '../modal/communication/newroom/modal-communication-newroom.component'
import { LayoutAppElementDetailComponent } from './layout-app-element-detail/layout-app-element-detail.component'
import { LayoutAppClientDetailComponent } from './layout-app-client-detail/layout-app-client-detail.component'
import { ModalTimelineRoomComponent } from '../modal/communication-room/timeline/modal-timeline-room.component'
import { ModalDeviceInfoComponent } from '../modal/client-detail/device-info/device-info.component'
import { ModalListImageTopComponent } from '../modal/client-detail/top/listImage/modal-list-image-top.component'
import { ModalListNoteTopComponent } from '../modal/client-detail/top/listnote/modal-list-note-top.component'
import { A2Edatetimepicker } from 'ng2-eonasdan-datetimepicker'
import { ModalDetailClientComplianceComponent } from '../modal/client/detail-client-compliance/modal-detail-client-compliance.component'
import { NgCircleProgressModule } from 'ng-circle-progress'
import { ModalBehaviorOptionSettingComponent } from '../modal/setting/behavior/modal-behavior-option-setting/modal-behavior-option-setting.component'
import { ModalBehaviorFormSettingComponent } from '../modal/setting/behavior/modal-behavior-form-setting/modal-behavior-form-setting.component'
import { ModalDetailBehaviorFormSettingComponent } from '../modal/setting/behavior/modal-detail-behavior-form-setting/modal-detail-behavior-form-setting.component'
import { ModalTreatmentComponent } from '../modal/client-detail/aligner/modal-treatment/modal-treatment.component'
import { ModalBehaviorConditionTargetComponent } from '../modal/setting/behavior/modal-behavior-condition-target/modal-behavior-condition-target.component'
import { ThemeComponent } from './setting/theme/theme.component'
import { ModalBehaviorConditionValueComponent } from '../modal/setting/behavior/modal-behavior-condition-value/modal-behavior-condition-value.component'
import { ShardModule } from '../../shard.module'
import { ModalTimelineClientDetailComponent } from '../modal/client-detail/timeline/timeline/modal-timeline-client-detail.component'
import { ModalCommunicationClientDetailComponent } from '../modal/client-detail/communication/modal-communication-client-detail.component'
import { ModalFormTimelineTopComponent } from '../modal/client-detail/timeline/modal-form-timeline-top/modal-form-timeline-top.component'
import { ModalSearchTimlineComponent } from '../modal/client-detail/timeline/modal-search-timline/modal-search-timline.component'
import { CommonsModule } from '../../commons/commons.module';
import { LayoutAppNotFoundComponent } from './layout-app-not-found/layout-app-not-found.component'


@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        AppElementRouting,
        ReactiveFormsModule,
        ScrollbarModule,
        A2Edatetimepicker,
        OnsenModule,
        CommonsModule,
        QRCodeModule,
        ShardModule,
        // Specify ng-circle-progress as an import
        NgCircleProgressModule.forRoot({
            // set defaults here
            radius: 100,
            outerStrokeWidth: 16,
            innerStrokeWidth: 8,
            outerStrokeColor: '#0080ff',
            innerStrokeColor: '#53a9ff',
            animationDuration: 300,
        }),
    ],
    declarations: [
        LayoutAppElementComponent,
        AppElementComponent,
        ModalMailHistoryComponent,
        ModalBroadcastMailFailedComponent,
        ModalAuditComponent,
        ModalLanguageComponent,
        ModalStaffEditComponent,
        SubmenuboxComponent,
        ModalClinicEditComponent,
        ModalCommonSaveComponent,
        ModalNewClientDoctorComponent,
        ModalMailComponent,
        ModalCommunicationNewroomComponent,
        LayoutAppElementDetailComponent,
        LayoutAppClientDetailComponent,
        ProfileClientComponent,
        ModalTimelineRoomComponent,
        ModalListNoteTopComponent,
        ModalDeviceInfoComponent,
        ModalTimelineClientDetailComponent,
        ModalCommunicationClientDetailComponent,
        ModalListImageTopComponent,
        ModalDetailClientComplianceComponent,
        ModalTreatmentComponent,
        ModalBehaviorOptionSettingComponent,
        ModalBehaviorFormSettingComponent,
        ModalDetailBehaviorFormSettingComponent,
        ModalBehaviorConditionTargetComponent,
        ModalBehaviorConditionValueComponent,
        ModalBehaviorSettingFormInTimelineComponent,
        SafeHtmlPipe,
        ThemeComponent,
        ModalFormTimelineTopComponent,
        ModalSearchTimlineComponent,
        LayoutAppNotFoundComponent,
    ],
    bootstrap: [AppElementComponent],
    providers: [
        ModalService,
        SelectclientService,
        ClientDetailServices,
    ],
    // bootstrap: [AppElementComponent],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
    ],
    exports: [ThemeComponent],
})
export class AppElementModule {
}

// platformBrowserDynamic().bootstrapModule(AppElementModule);



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/appElement.module.ts